import { ChangePassword } from '@app/pcs/models/change-password';
import { Action } from '@ngrx/store';

export enum UserChangePasswordActionTypes {
  ChangePassword = '[UserChangePassword] Change Password',
  ChangePasswordSuccess = '[UserChangePassword] Change Password Success',
  ChangePasswordFailure = '[UserChangePassword] Change Password Failure',
}

export class UserChangePassword implements Action {
  readonly type = UserChangePasswordActionTypes.ChangePassword;

  constructor(public payload: { changePassword: ChangePassword; redirectAction?: Action }) {
  }
}

export class UserChangePasswordSuccess implements Action {
  readonly type = UserChangePasswordActionTypes.ChangePasswordSuccess;
}

export class UserChangePasswordFailure implements Action {
  readonly type = UserChangePasswordActionTypes.ChangePasswordFailure;
}

export type UserChangePasswordActions =
  | UserChangePassword
  | UserChangePasswordSuccess
  | UserChangePasswordFailure;
